/* Import libraries */
import Popper from 'popper.js';
import 'bootstrap';
import $ from 'jquery';
import 'slick-carousel';
import Vue from 'vue';
import StickySidebar from "sticky-sidebar";

/* import custom JS */
import wayPointAnimations from "./components/wayPointAnimations";
import equalSizes from "./components/equalSizes";
import postfilterpage from './vue/PostFilterPage.vue';
import search from './vue/Search.vue';
import toolproducts from './vue/ToolProducts';
import toolmembership from './vue/ToolMembership';
import './components/toggler';
import articleMenu from './components/articleMenu';
import scrollToTop from './components/scrollToTop';
import Cart from './components/Cart';
import Animations from "./components/Animations";
import Form from "./components/Form";
import GForm from "./components/GForm";
import {deleteCookie} from './components/cookies';
import LoginModal from "./components/LoginModal";
import scrollLinks from "./components/scrollLinks";
import Account from "./components/Account";

import 'jquery-match-height';

window.$ = window.jQuery = $;

window.addEventListener('DOMContentLoaded', (event) => {
  const hideLogin = document.body.getAttribute('data-hide-login');

  if (hideLogin !== 'true') {
    new LoginModal(
      'inretail_login_modal',
      7,
      true,
      false,
      'loginModal'
    );
  }
  new LoginModal(
    'inretail_userdata_modal',
    .04166666667,
    false,
    true,
    'user_data_modal',
    150
  );

  new scrollLinks();

  let articleInfoToggler = document.getElementById('article-info-toggler');
  if (articleInfoToggler) {
    articleInfoToggler.onclick = function (e) {
      e.preventDefault();
      document.getElementById('article-info').classList.toggle('active');
    };
  }

  new Cart([...document.getElementsByClassName('js-amount')]);

  new wayPointAnimations();
  new equalSizes();
  new articleMenu();
  new scrollToTop();
  new Animations();
  new Form();
  new Account();

  jQuery('[data-toggle="tooltip"]').tooltip();

  stickyHeader();
  jQuery('[data-mh]').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: true
  });

  if (document.getElementById('site-footer')) {
    document.documentElement.style.setProperty('--footer-height', document.getElementById('site-footer').offsetHeight + "px");
  }

  if (window.location.href.includes('login=failed') && document.getElementById('loginModal')) {
    // Flush cookie which hides the modal.
    deleteCookie('inretail_login_modal');
    // Force show modal.
    jQuery('#loginModal').modal('show');
  }

});

window.addEventListener('resize', (event) => {
  new equalSizes();

  stickyHeader();
});

window.addEventListener('scroll', function () {
  stickyHeader();
});

if (document.getElementById('app')) {
  new Vue({
    el: '#app',
    components: {
      postfilterpage,
      search,
      toolproducts,
      toolmembership
    }
  });
}

jQuery('.js-slider-more').each(function () {

  let isProduct = document.body.classList.contains('single-product');

  jQuery(this).slick({
    mobileFirst: true,
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: true === isProduct ? 6 : 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: true === isProduct ? 4 : 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }).on('setPosition', function () {
    jQuery(this).find('.slick-slide').height('auto');

    let slickTrack = jQuery(this).find('.slick-track'),
      slickTrackHeight = jQuery(slickTrack).height();

    jQuery(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
  });
});
jQuery('.js-slider-quote').each(function () {
  jQuery(this).slick({
    mobileFirst: true,
    dots: true,
    arrows: false,
    infinite: true,
    speed: 375,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          fade: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          fade: true
        }
      }
    ],
    customPaging: function (slider, i) {
      let color = slider.$slides[i].querySelector('article').dataset.dotColor || 'red';
      return '<button type="button" role="tab" tabindex="0" class="text-' + color + '">' + i + '</button>';
    },
  })
    .on('setPosition', function () {
      jQuery(this).find('.slick-slide').height('auto');

      let slickTrack = jQuery(this).find('.slick-track'),
        slickTrackHeight = jQuery(slickTrack).height();

      jQuery(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
    })
});
jQuery('.js-slider-theme').each(function () {
  jQuery(this).slick({
    mobileFirst: true,
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }).on('setPosition', function () {
    jQuery(this).find('.slick-slide').height('auto');

    let slickTrack = jQuery(this).find('.slick-track'),
      slickTrackHeight = jQuery(slickTrack).height();

    jQuery(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
  });
});
jQuery('.js-slider-brand').each(function () {
  jQuery(this).slick({
    mobileFirst: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    centerMode: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          centerMode: false
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  }).on('setPosition', function () {
    jQuery(this).find('.slick-slide').height('auto');

    let slickTrack = jQuery(this).find('.slick-track'),
      slickTrackHeight = jQuery(slickTrack).height();

    jQuery(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
  });
});
jQuery('.js-article-slider').each(function () {
  jQuery(this).slick({
    mobileFirst: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 3500,
    arrows: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }).on('setPosition', function () {
    jQuery(this).find('.slick-slide').height('auto');

    let slickTrack = jQuery(this).find('.slick-track'),
      slickTrackHeight = jQuery(slickTrack).height();

    jQuery(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
    jQuery(this).find('.col').css('height', slickTrackHeight + 'px');
  });
});

if (!CSS.supports('position', 'sticky') && document.getElementById('sidebar')) {
  new StickySidebar('#sidebar', {
    containerSelector: '.row',
    innerWrapperSelector: '.sidebar__inner',
    topSpacing: 160,
    bottomSpacing: 160,
    minWidth: 991
  });
}

jQuery('.modal')
  .on('shown.bs.modal', function (e) {
    if (document.body.classList.contains('menu-active')) {
      document.body.classList.remove('menu-active');
    }
  }).on('hide.bs.modal', function (e) {
  // Remove ?cbw=XXX from url
  const regex = /[?|&]cbw=([0-9]{5,7})/i;
  if (window.location.href.match(regex)) {
    const url = window.location.href.replace(regex, '');
    window.history.pushState('', document.title, url);
  }

  // Cleanup of all iframes
  const holder = document.getElementById('load-form');
  if (holder) {
    [...holder.getElementsByTagName('iframe')].forEach(el => {
      el.parentNode.removeChild(el);
    });
    holder.classList.remove('loaded');
  }
});

// Append Iframe within modal
jQuery(document).on('click', '.js-cbw-modal', function () {
  const ifrm = document.createElement("iframe");
  ifrm.setAttribute('src', window.location.href + '?cbw=' + this.getAttribute('data-cbw'));
  ifrm.setAttribute('title', this.getAttribute('data-cbw') + ' | ' + document.title)
  ifrm.setAttribute('loading', 'eager');
  ifrm.setAttribute('frameborder', '0')
  ifrm.style.width = "100%";
  ifrm.style.height = (window.innerHeight * .65) + "px";
  document.getElementById('load-form').appendChild(ifrm);
  setTimeout(function () {
    document.getElementById('load-form').classList.add('loaded');
  }, 2500);
});

function stickyHeader() {
  if (!document.body.classList.contains('home')) {
    return;
  }
  if (document.body.scrollTop > 32 || document.documentElement.scrollTop > 32) {
    document.body.classList.add('header-sticky');
  } else {
    document.body.classList.remove('header-sticky');
  }
}

jQuery(document).on("gform_confirmation_loaded", function (e, form_id) {

    // Return if no ajax_object
    if (!ajax_object.quote_form) {
      return;
    }

    // Return if not the same ID.
    if (parseInt(form_id) !== parseInt(ajax_object.quote_form)) {
      return;
    }

    const header = document.getElementById('header');
    if (!header) {
      // within iframe.
      return;
    }

    const scrollY = window.scrollY - header.offsetHeight;

    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        top: scrollY,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      // CSS animation in browser.
      window.scrollTo(0, scrollY);
    }
  }
);

if (typeof cbwIds !== "undefined") {
  var jsonObject = JSON.parse(cbwIds);
  var promises = [];
  var counter = 0;

  jQuery.each(jsonObject, function (index, object) {

    var request = jQuery.ajax({
      url: ajax_object.ajax_url,
      method: 'post',
      type: 'json',
      data: {
        'ID': object.ID,
        'key': index,
        'action': 'get_cbw_information',
        'nonce': ajax_object.cbw_nonce
      },
      success: function (response) {
        if (response.success) {
          counter++;
          jQuery('span#cbw-count').text(`(${counter})`);
          jQuery('div.cbw-entries').append(response.data.html);
          jQuery(`#cbw-panel-${object.ID}`).collapse({toggle: false});
        }
      }
    });
    promises.push(request);
  });

  jQuery.when.apply(null, promises).done(function () {
    jQuery('span#cbw-count').text(ajax_object.translations.done);
  })
}

jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
  new GForm(document.getElementById('gform_' + form_id));
});

// code to be trigger when confirmation page is loaded, used for CBW refresh
jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
  if (parseInt(ajax_object.cbw_form_id) === formId) {
    setTimeout(function () {
      parent.location.reload();
    }, 2000);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var inputElements = document.querySelectorAll('.kvk-auto > * > input');

  inputElements.forEach(function (inputElement) {
    var loadingIndicator = document.createElement('div');
    loadingIndicator.textContent = 'Even geduld alstublieft...';
    loadingIndicator.style.display = 'none';
    inputElement.parentElement.appendChild(loadingIndicator);

    inputElement.addEventListener('input', function () {
      var kvkNummer = this.value;

      loadingIndicator.style.display = 'block';  // Toon de laadindicator

      fetch(`/wp-json/inretail/v1/kvk/${kvkNummer}`)
        .then(response => response.json())
        .then(result => {
          for (const [key, value] of Object.entries(result)) {
            const liElement = document.querySelector(`.kvk-auto-${key}`);
            if (liElement) {
              const inputField = liElement.querySelector('input');
              if (inputField) {
                inputField.value = value;
                liElement.classList.add('is-focus', 'is-valid');
              }
            }
          }

          loadingIndicator.style.display = 'none';  // Verberg de laadindicator
        })
        .catch(error => {
          console.log('error', error);
          loadingIndicator.style.display = 'none';  // Verberg de laadindicator
        });
    });
  });
});

/*
 * The DOMContentLoaded event listener performs the following actions:
 *
 * - It selects all form elements on the page.
 * - For each form, it checks if there's a hidden input field with the value "{claim-nummer}".
 * - If such a field exists, it adds listeners to the form fields to generate a claimnumber.
 *
 * The claimnumber is based on the following format:
 * [currentYear].[firstTextInputValue].[currentDate][currentTime]
 *
 * The code assumes the first input field of the form is a text input field containing the "lidnummer".
 */
document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('form');

  if (forms.length > 0) {
    forms.forEach(form => {
      const hiddenField = form.querySelector('input[type="hidden"][value="{claim-nummer}"]');
      if (hiddenField) {
        const fields = form.querySelectorAll('input, textarea, select');
        const firstTextInput = form.querySelector('input[type="text"]');
        const currentYear = new Date().getFullYear();
        const currentDate = (new Date().getMonth() + 1) + '' + new Date().getDate();

        fields.forEach(field => {
          field.addEventListener('input', () => {
            const currentTime = new Date().getHours() + '' + (new Date().getMinutes().toString().padStart(2, '0'));

            hiddenField.value = `${currentYear}.${firstTextInput.value}.${currentDate}${currentTime}`;
          });
        });
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const priceContainer = document.querySelector('.price-container');
  const form = document.querySelector('.gform_wrapper form');

  if (priceContainer && form) {
    const fields = form.querySelectorAll('.gfield');

    fields.forEach(field => {
      const hasGroupClass = Array.from(field.classList).some(className => className.startsWith('group-'));

      if (hasGroupClass) {
        const inputs = field.querySelectorAll('input');
        inputs.forEach(input => {
          input.addEventListener('change', () => {
            recalculatePrice(); // Call the recalculatePrice function
          });
        });
      }
    });
  }
});

function recalculatePrice() {
  // Add your custom logic for recalculating the price here

  const priceContainer = document.querySelector('.price-container');
  const form = document.querySelector('.gform_wrapper form');

  if (priceContainer && form) {
    const fields = form.querySelectorAll('.gfield');

    let totalPriceLeden = 0;
    let totalPriceNietLeden = 0;
    const processedGroups = new Set(); // Set to keep track of processed groups
    let priceCalculated = false;

    fields.forEach(field => {
      const groupClass = Array.from(field.classList).find(className => className.startsWith('group-'));

      if (groupClass && !processedGroups.has(groupClass)) {
        processedGroups.add(groupClass);

        // Find all elements in the form with the same group- class
        const checkbox = form.querySelector(`.${groupClass} input[type="checkbox"]`);

        // Add your custom logic for each group element here
        if (checkbox && checkbox.checked) {
          const numberFieldContainer = form.querySelector(`.${groupClass}.gfield--type-number`);
          const priceLedenElement = form.querySelector(`.${groupClass}.price-leden`);
          const priceNietLedenElement = form.querySelector(`.${groupClass}.price-niet-leden`);

          let numberValue = 0;
          let priceLeden = 0;
          let priceNietLeden = 0;

          if (numberFieldContainer) {
            // Find the input field inside the number field container
            let numberInput = numberFieldContainer.querySelector('input');

            if (numberInput) {
              // Store the number in a variable
              numberValue = parseFloat(numberInput.value);
            }
          }

          if (priceLedenElement) {
            const hiddenInput = priceLedenElement.querySelector('input[type="hidden"][id*="base_price"]');

            if (hiddenInput) {
              // Store the hidden input value in a variable
              let hiddenInputValue = hiddenInput.value;
              hiddenInputValue = hiddenInputValue.replace(' €', '').replace(',', '.');
              priceLeden = parseFloat(hiddenInputValue);
            }
          }

          if (priceNietLedenElement) {
            const hiddenInput = priceNietLedenElement.querySelector('input[type="hidden"][id*="base_price"]');

            if (hiddenInput) {
              // Store the hidden input value in a variable
              let hiddenInputValue = hiddenInput.value;
              hiddenInputValue = hiddenInputValue.replace(' €', '').replace(',', '.');
              priceNietLeden = parseFloat(hiddenInputValue);
            }
          }

          if (numberValue) {
            totalPriceLeden += priceLeden * numberValue;
            totalPriceNietLeden += priceNietLeden * numberValue;
            // Update the price container with the new total price

            priceCalculated = true;
          }
        }
      }
    });

    const formattedTotalPriceLeden = totalPriceLeden.toLocaleString('nl-NL', {style: 'currency', currency: 'EUR'});
    const formattedTotalPriceNietLeden = totalPriceNietLeden.toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    });

    if (priceCalculated) {
      priceContainer.querySelector('.product-price-member').textContent = formattedTotalPriceLeden;
      priceContainer.querySelector('.product-price-regular').textContent = formattedTotalPriceNietLeden;
    }
  }
}

window.addEventListener('load', function () {
  const gridCols = document.querySelectorAll('.gform-grid-col');

  // Check if the gridCols contain <br> tags
  gridCols.forEach(gridCol => {
    const brTags = gridCol.querySelectorAll('br');

    if (brTags.length > 0) {
      // Remove the <br> tags
      brTags.forEach(brTag => {
        brTag.remove();
      });
    }
  });
});


const categoryDropdown = document.getElementById('category-dropdown');
if (categoryDropdown) {
  categoryDropdown.addEventListener('change', function () {
    var selectedLevel = this.value;
    document.querySelectorAll('article[data-level]').forEach(function (article) {
      if (!selectedLevel || article.getAttribute('data-level') === selectedLevel) {
        article.style.display = '';
      } else {
        article.style.display = 'none';
      }
    });
  });
}
